import { SHOW_ALERT } from '../actionTypes';
import { alertsActions } from '../reducer';

export default (data) =>
    alertsActions[SHOW_ALERT]({
        ...data,
        haveTextCaptcha: data.haveTextCaptcha,
    });
